export const buttonStyle =
  'inline-flex items-center justify-center rounded-md border  px-4 py-2 text-sm font-medium text-primary border-primary shadow-sm hover:bg-primary-lighter focus:bg-primary focus:text-white focus:outline-none sm:w-auto';
